import { LAYOUT } from '@admin/router/constant'

// 拓色拓身形管理路由
const colorExpandRouter = {
  path: '/cosSystem',
  name: '',
  component: LAYOUT,
  children: [
    // 拓色管理
    {
      path: '/cos/color-expand/category-rules',
      name: 'ColorExpandCategoryRules',
      component: () => import('@admin/views/cos/colorExpand/categoryRules/index.vue'),
      meta: { helpUrl: '', title: '品类拓色拓款规则' },
    },
    {
      path: '/cos/color-expand/plm-progress',
      name: 'ColorExpandPlmProgress',
      component: () => import('@admin/views/cos/colorExpand/plmProgress/index.vue'),
      meta: { helpUrl: '', title: '拓色明细PLM进度查询' },
    },
    {
      path: '/cos/color-expand/decision',
      name: 'ColorExpandDecision',
      component: () => import('@admin/views/cos/colorExpand/decision/index.vue'),
      meta: { helpUrl: '', title: '拓色决策' },
    },
    {
      path: '/cos/color-expand/decision-order',
      name: 'ColorExpandDecisionOrder',
      component: () => import('@admin/views/cos/colorExpand/decisionOrder/index.vue'),
      meta: { helpUrl: '', title: '拓色决策单' },
    },
    {
      path: '/cos/color-expand/decision-order/detail',
      name: 'ColorExpandDecisionOrderDetail',
      component: () => import('@admin/views/cos/colorExpand/decisionOrder/detail.vue'),
      meta: {
        helpUrl: '',
        title: '拓色决策详情',
        hideMenu: true,
        currentActiveMenu: '/cos/color-expand/decision-order',
      },
    },

    // 拓色拓款管理
    {
      path: '/cos/body-expand/decision',
      name: 'BodyExpandDecision',
      component: () => import('@admin/views/cos/bodyExpand/decision/index.vue'),
      meta: { helpUrl: '', title: '拓身形决策' },
    },
    {
      path: '/cos/body-expand/decision-order',
      name: 'BodyExpandDecisionOrder',
      component: () => import('@admin/views/cos/bodyExpand/decisionOrder/index.vue'),
      meta: { helpUrl: '', title: '拓身形决策单' },
    },
    {
      path: '/cos/body-expand/plm-progress',
      name: 'BodyExpandPlmProgress',
      component: () => import('@admin/views/cos/bodyExpand/plmProgress/index.vue'),
      meta: { helpUrl: '', title: '拓身形PLM进度查询' },
    },

    // 商品刊登 - 组合商品
    {
      path: '/cos/goods-publish/combine',
      name: 'CombineProduct',
      component: () => import('@admin/views/cos/goodsPublish/combine/index.vue'),
      meta: { helpUrl: '', title: '组合商品' },
    },
  ],
}

export default colorExpandRouter
